export default "__VITE_ASSET__DZwKK992__"